import styleInject from '../../../dependencies/style-inject/dist/style-inject.es.js';

var css_248z = ".rf-popper__content[data-v-6e52f9c7] {\n  z-index: 1000;\n  background-color: var(--neutral-00);\n  box-shadow: var(--shadow-lvl3);\n  border: 1px solid var(--neutral-05);\n  border-radius: 8px;\n  max-width: inherit;\n  width: auto;\n  overflow: hidden;\n}";
styleInject(css_248z);

export { css_248z as default };
